// extracted by mini-css-extract-plugin
export var chevron = "_12-d";
export var disabled = "_12-b";
export var error = "_12-c";
export var hideBorder = "_12-1";
export var icon = "_12-e";
export var input = "_12-0";
export var large = "_12-f";
export var open = "_12-9";
export var placeholder = "_12-a";
export var regular = "_12-5";
export var singleRowInput = "_12-2";
export var singleSelectInput = "_12-3 _12-0";
export var small = "_12-4";
export var spinnerContainer = "_12-h";
export var tag = "_12-7";
export var tagsContainer = "_12-8";
export var tagsInput = "_12-6 _12-0";
export var xSmall = "_12-g";